import React from 'react';
import { observer } from 'mobx-react';
import {
    Grid,
    Switch,
    Tooltip,
} from '@material-ui/core';

import Dialog from '../../commons/dialog/Dialog';
import useEcalWorldFeaturedSwitch from './useEcalWorldFeaturedSwitch';

function EcalWorldFeaturedSwitch (props) {
    const {
        isFeatured,
        confirmOpen,
        tooltipTitle,
        dialogTitle,
        dialogText,
        handleToggle,
        handleConfirm,
        handleCancel,
        renderErrorDialog,
    } = useEcalWorldFeaturedSwitch(props);

    return (
        <Grid>
            <Tooltip title={tooltipTitle}>
                <Switch
                    checked={isFeatured}
                    onClick={handleToggle}
                    color="primary"
                    inputProps={{ 'aria-label': 'ECAL World featured publisher' }}
                />
            </Tooltip>

            <Dialog
                openDialog={confirmOpen}
                buttonSecondary={'Cancel'}
                handleAgree={handleConfirm}
                closeModal={handleCancel}
                title={dialogTitle}
                dialogContextText={dialogText}
            />

            { renderErrorDialog() }
        </Grid>
    );
}

const ObservedEcalWorldFeaturedSwitch = observer(EcalWorldFeaturedSwitch);
export default ObservedEcalWorldFeaturedSwitch;
